"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  aqua50: '#e6fcf8',
  aqua100: '#b8f6eb',
  aqua200: '#8af0df',
  aqua300: '#5cead2',
  aqua400: '#2de4c6',
  aqua500: '#00dec3',
  aqua600: '#00bb9b',
  aqua700: '#00977e',
  aqua800: '#007360',
  aqua900: '#015043',
  aqua950: '#00211c',
  blue50: '#e6f0ff',
  blue100: '#b8d5ff',
  blue200: '#8abbff',
  blue300: '#5ca0ff',
  blue400: '#2e85ff',
  blue500: '#006aff',
  blue600: '#0d59c4',
  blue700: '#14478f',
  blue800: '#153460',
  blue900: '#102136',
  blue950: '#080c11',
  celeste50: '#e6faff',
  celeste100: '#b8f0ff',
  celeste200: '#8ae5ff',
  celeste300: '#5cd7ff',
  celeste400: '#2ec9ff',
  celeste500: '#00b8ff',
  celeste600: '#0097d1',
  celeste700: '#0076a3',
  celeste800: '#005575',
  celeste900: '#003447',
  celeste950: '#00121a',
  green50: '#ECF8EE',
  green100: '#C3E9CB',
  green200: '#9BD8AA',
  green300: '#73C886',
  green400: '#4BB962',
  green500: '#28A745',
  green600: '#1B993B',
  green700: '#177B30',
  green800: '#115D24',
  green900: '#0C3D17',
  green950: '#071F0B',
  neutral0: '#ffffff',
  neutral100: '#f7f9fc',
  neutral200: '#edf1f7',
  neutral300: '#e4e9f2',
  neutral400: '#c5cee0',
  neutral500: '#7e8aa4',
  neutral600: '#5f6879',
  neutral700: '#495160',
  neutral800: '#333a46',
  neutral900: '#1e232c',
  neutral950: '#0b0c10',
  orange50: '#FFEFEB',
  orange100: '#FFD1C2',
  orange200: '##FFB298',
  orange300: '#FF946C',
  orange400: '#FF763F',
  orange500: '#FF5720',
  orange600: '#D44706',
  orange700: '#BC3F09',
  orange800: '#8F3007',
  orange900: '#5E1F06',
  orange950: '#471706',
  pjbank: '#00c1de',
  pink50: '#ffeaf2',
  pink100: '#ffc4da',
  pink200: '#ff9ec2',
  pink300: '#ff79aa',
  pink400: '#ff5392',
  pink500: '#ff2d7a',
  pink600: '#d6135a',
  pink700: '#ad023e',
  pink800: '#850025',
  pink900: '#5c0012',
  pink950: '#330005',
  purple50: '#f3ebfe',
  purple100: '#ddc6fb',
  purple200: '#c6a2f9',
  purple300: '#b27df7',
  purple400: '#9c59f4',
  purple500: '#8634f2',
  purple600: '#712ccb',
  purple700: '#5a23a5',
  purple800: '#461b7e',
  purple900: '#301357',
  purple950: '#1b0a30',
  red50: '#ffe6e6',
  red100: '#ffbbbb',
  red200: '#ff9494',
  red300: '#ff7070',
  red400: '#ff5050',
  red500: '#f83333',
  red600: '#d61d1e',
  red700: '#ad0d0d',
  red800: '#850202',
  red900: '#5c0000',
  red950: '#330000',
  violet50: '#e6e6ff',
  violet100: '#b8b8ff',
  violet200: '#958aff',
  violet300: '#7b5cff',
  violet400: '#672eff',
  violet500: '#5700f8',
  violet600: '#4700cb',
  violet700: '#38009f',
  violet800: '#280072',
  violet900: '#180045',
  violet950: '#090019',
  yellow50: '#FFFAEB',
  yellow100: '#FFEFC2',
  yellow200: '#FFE39A',
  yellow300: '#FFD76F',
  yellow400: '#FFCD42',
  yellow500: '#ffc02a',
  yellow600: '#EAB000',
  yellow700: '#BB8D02',
  yellow800: '#8D6B05',
  yellow900: '#5E4607',
  yellow950: '#2F2304',
  white: '#FFFFFF'
};
exports.default = _default;